import { TmFormError } from '@/core/error/tmFormError'

export class TmFormBuilderError extends TmFormError {
  public name = 'TmFormBuilderError'
}
